import React, { useEffect, useState } from 'react';
import { Button, Progress } from 'reactstrap';
import Form1 from './Form1';
import Form2 from './Form2';
import cogoToast from 'cogo-toast';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_QUIZ_GAME, GET_GAMIFICATION_LIST, UPDATE_GAME_STATUS } from '../../../../../../../../store/actions';
import moment from 'moment';
import { FaArrowLeft } from 'react-icons/fa';

const totalSteps = 2;

const Quiz = ({ currentGameDetails }) => {
  const dispatch = useDispatch();

  const [step, setStep] = useState(1);
  const [form1Data, setForm1Data] = useState({
    game_id: '',
    game_name: '',
    type: '',
    banner: null,
    status: '',
    start_date: '',
    end_date: '',
    min_coins_required: '',
    play_duration: '',
    play_duration_unit: '',
    reward_type: '',
    points: '',
    benefits: '',
    description: '',
    serviceConfigId: '',
    max_unit_allowed: '',
    is_featured: false,
  });

  const [form1Errors, setForm1Errors] = useState({});
  const [questions, setQuestions] = useState([{ question: '', options: ['', '', '', ''], correctIndex: 0, questionId: '', optionId: [] }]);

  useEffect(() => {
    if (currentGameDetails !== null) {
      dispatch({
        type: GET_GAMIFICATION_LIST,
        payload: {
          game_id: currentGameDetails?.game_id,
        },
      });
    }
  }, [currentGameDetails]);

  const { getGamificationList } = useSelector((state: any) => ({
    getGamificationList: state?.GetGamificationList?.data,
  }));

  console.log('form1Data', form1Data);

  useEffect(() => {
    if (getGamificationList !== null) {
      const initialGameDetails = {
        game_id: getGamificationList?.game_id || '',
        game_name: getGamificationList?.game_name || '',
        type: getGamificationList?.type || '',
        status: getGamificationList?.status || '',
        min_coins_required: getGamificationList?.min_coins_required ?? '',
        start_date: getGamificationList?.start_date || '',
        end_date: getGamificationList?.end_date || '',
        play_duration: getGamificationList?.play_duration || '',
        play_duration_unit: getGamificationList?.play_duration_unit || '',
        tat: getGamificationList?.tat,
        tat_unit: getGamificationList?.tat_unit,
        total_attempts: getGamificationList?.total_attempts,
        reward_type: getGamificationList?.rewards?.[0]?.type,
        points: getGamificationList?.rewards?.[0]?.points,
        benefits: getGamificationList?.rewards?.[0]?.reward_id,
        description: getGamificationList?.description,
        banner: getGamificationList?.banner,
        serviceConfigId: getGamificationList?.rewards?.[0]?.service_config_id || '',
        max_unit_allowed: String(getGamificationList?.rewards?.[0]?.max_unit_allowed),
        is_featured: getGamificationList?.is_featured,
      };

      const intialQuestions = getGamificationList?.questions?.map(q => ({
        question: q.question_text,
        options: q.options?.map(opt => opt.option_text) || ['', '', '', ''],
        correctIndex: q.options?.findIndex(opt => opt.is_correct) || 0,
        questionId: q.question_id || '',
        optionId: q.options?.map(opt => opt.option_id) || [],
      })) || [{ question: '', options: ['', '', '', ''], correctIndex: 0 }];

      setForm1Data(initialGameDetails);
      setQuestions(intialQuestions);
    }
  }, [getGamificationList]);

  console.log('form1Data', form1Data);

  const validateForm1 = () => {
    const errors: any = {};

    if (!form1Data.game_name?.trim()) errors.game_name = 'Quiz Name is required';

    if (form1Data?.game_name?.trim().length > 50) errors.game_name = 'Quiz name must be under 50 characters';

    if (!form1Data.banner) errors.banner = 'Quiz Banner is required';
    if (!form1Data.status) errors.status = 'Status is required';
    if (!form1Data.start_date) errors.start_date = 'Start Date is required';
    if (!form1Data.end_date) errors.end_date = 'End Date is required';

    if (form1Data.start_date && form1Data.end_date) {
      const start = new Date(form1Data.start_date);
      const end = new Date(form1Data.end_date);

      if (end < start) {
        errors.end_date = 'End Date must be greater than or equal to Start Date';
      }
    }
    if (
      form1Data.min_coins_required === '' ||
      form1Data.min_coins_required === null ||
      form1Data.min_coins_required === undefined ||
      Number(form1Data.min_coins_required) < 0
    )
      errors.min_coins_required = 'Min Points is required';
    if (!form1Data.play_duration) {
      errors.play_duration = 'Play Duration is required';
    }
    if (form1Data?.play_duration_unit == 'minutes') {
      if (Number(form1Data?.play_duration) > 59 || Number(form1Data?.play_duration) < 1) {
        errors.play_duration = 'Spin time should be in betweeen 1 to 59 minutes';
      }
    }
    if (form1Data?.play_duration_unit == 'seconds') {
      if (Number(form1Data?.play_duration) > 60 || Number(form1Data?.play_duration) < 1) {
        errors.play_duration = 'Spin time should be in betweeen 1 to 60 seconds';
      }
    }
    if (!form1Data.play_duration_unit) {
      errors.play_duration_unit = 'Play Duration is required';
    }

    if (!form1Data.max_unit_allowed) {
      errors.max_unit_allowed = 'Max Unit is required';
    }

    if (form1Data.max_unit_allowed) {
      if (Number(form1Data.max_unit_allowed) < 1) {
        errors.max_unit_allowed = 'Unit should be greater then or equal to 1';
      }
    }

    if (!form1Data.reward_type) {
      errors.reward_type = 'Reward Type is required';
    }

    if (form1Data.reward_type === 'points' && !form1Data.points) {
      errors.points = 'Points is required';
    }

    if (form1Data.reward_type === 'points' && Number(form1Data.points) <= 0) {
      errors.points = 'Points must be greater than or equal to 1';
    }

    if (!form1Data.benefits) errors.benefits = 'Quiz Price is required';

    if (!form1Data.description || form1Data.description.trim() === '') {
      errors.description = 'Quiz Info is required';
    }

    setForm1Errors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleForm1Change = (field, value) => {
    setForm1Data(prev => ({ ...prev, [field]: value }));
    setForm1Errors(prev => ({ ...prev, [field]: '' }));
  };

  const handleFlatpickrChange = (name, date) => {
    setForm1Data(prev => ({
      ...prev,
      [name]: moment(new Date(date[0])).format('Y-MM-DD'),
    }));
    if (form1Errors[name]) {
      setForm1Errors(prevErrors => ({ ...prevErrors, [name]: undefined }));
    }
  };

  const handleNext = () => {
    if (validateForm1()) setStep(2);
  };

  const handleSubmit = () => {
    const isValid = questions.every((q, index) => {
      const hasQuestion = q.question.trim() !== '';
      const allOptionsFilled = q.options.every(opt => opt.trim() !== '');
      return hasQuestion && allOptionsFilled;
    });

    if (!isValid) {
      cogoToast.error('All questions and options must be filled.');
      return;
    }

    const payload = {
      game_name: form1Data.game_name,
      description: form1Data.description,
      banner: form1Data.banner,
      status: form1Data.status,
      min_coins_required: form1Data.min_coins_required ? Number(form1Data.min_coins_required) : 0,
      start_date: form1Data?.start_date,
      end_date: form1Data?.end_date,
      play_duration: form1Data.play_duration ? Number(form1Data.play_duration) : 0,
      play_duration_unit: form1Data.play_duration_unit,
      total_attempts: 1,
      tat: 1,
      tat_unit: 'seconds',
      rewards: [
        {
          type: form1Data.reward_type,
          reward_id: form1Data.benefits || '',
          points: form1Data.points ? Number(form1Data.points) : 0,
          max_unit_allowed: form1Data.max_unit_allowed ? Number(form1Data.max_unit_allowed) : 1,
          ...(form1Data?.serviceConfigId && { service_config_id: form1Data?.serviceConfigId }),
        },
      ],
      is_featured: form1Data?.is_featured,
    };

    if (currentGameDetails) {
      dispatch({
        type: UPDATE_GAME_STATUS,
        payload: {
          data: {
            ...payload,
            game_id: form1Data?.game_id,
            type: form1Data?.type || '',
            questions: questions.map(q => ({
              question_text: q.question,
              options: q.options?.map((opt, index) => {
                return {
                  option_text: opt,
                  is_correct: index === q.correctIndex,
                  ...(q.optionId?.length > 0 && { option_id: q.optionId[index] || '' }),
                };
              }),
              ...(q.questionId && { question_id: q.questionId || '' }),
            })),
          },
          type: form1Data?.type || '',
        },
      });
    } else {
      dispatch({
        type: CREATE_QUIZ_GAME,
        payload: {
          data: {
            ...payload,
            questions: questions.map(q => ({
              question_text: q.question,
              options: q.options?.map((opt, index) => {
                return { option_text: opt, is_correct: index === q.correctIndex };
              }),
            })),
          },
        },
      });
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-end mb-4">
        <span className="me-2 fw-semibold">
          Step {step} / {totalSteps}
        </span>

        {/* Step 1 progress */}
        <div style={{ width: '40px' }} className="me-2">
          <Progress
            value={step >= 1 ? 100 : 0}
            color="success"
            style={{
              height: '8px',
              borderRadius: '10px',
              backgroundColor: '#e9ecef', // ensures the unfilled bar is visible
            }}
          />
        </div>

        {/* Step 2 progress */}
        <div style={{ width: '40px' }}>
          <Progress
            value={step >= 2 ? 100 : 0}
            color="success"
            style={{
              height: '8px',
              borderRadius: '10px',
              backgroundColor: '#e9ecef', // ensures the unfilled bar is visible
            }}
          />
        </div>
      </div>

      {step === 1 && (
        <Form1
          formData={form1Data}
          errors={form1Errors}
          handleChange={handleForm1Change}
          handleFlatpickrChange={handleFlatpickrChange}
          handleNext={handleNext}
          setFormData={setForm1Data}
        />
      )}
      {step === 2 && (
        <>
          <Button color="link" onClick={() => setStep(1)} className="mb-3 d-flex align-items-center gap-1 p-0">
            <FaArrowLeft />
            Back
          </Button>

          <Form2 questions={questions} setQuestions={setQuestions} handleSubmit={handleSubmit} isUpdate={currentGameDetails ? true : false} />
        </>
      )}
    </div>
  );
};

export default Quiz;
